import { CommonModule } from '@angular/common';
import { HelpService } from './../../pages/help/help.service';
import { Component, Input, OnInit } from '@angular/core';
import { DxButtonModule } from 'devextreme-angular';

@Component({
    selector: 'app-help-button',
    imports: [
        CommonModule,
        DxButtonModule,
    ],
    templateUrl: './help-button.component.html',
    styleUrls: ['./help-button.component.scss'],
	standalone: true
})
export class HelpButtonComponent implements OnInit {

	@Input() public settingName: string;

	public onHelpButtonClicked(event: any) {
		

		this._helpService.openHelpPage(this.settingName);
	}

	constructor(
		private _helpService: HelpService,
	) { }

	ngOnInit() {
	}
}
